import React, { useState } from "react";
import { Circle, CheckCircle2, Video, FileText, Download } from "lucide-react";
import apiClient from "../../../utils/apiClient";

/**
 * StudentTopicRow
 *
 * Read-only topic row inside a student syllabus day card.
 *
 * Props:
 *   - index            : Number  (0-based topic index)
 *   - topic            : Object  { name, status, recordingUrl }
 *   - linkedMaterials  : Array   [{ _id, title, fileType, category }]
 */
const StudentTopicRow = ({ index, topic, linkedMaterials = [] }) => {
  const isCompleted = topic.status === "completed";
  const hasRecording = !!topic.recordingUrl;
  const [downloading, setDownloading] = useState(null);

  const handleDownload = async (mat) => {
    setDownloading(mat._id);
    try {
      const { data } = await apiClient.get(`/materials/${mat._id}/download`);
      if (data.data?.url) window.open(data.data.url, "_blank");
    } catch {}
    setDownloading(null);
  };

  return (
    <div className={`ss-topic-row ${isCompleted ? "ss-topic-completed" : ""}`}>
      {/* Left: index + icon + name */}
      <div className="ss-topic-left">
        <span className="ss-topic-index">{index + 1}.</span>
        <span
          className={`ss-topic-icon ${
            isCompleted ? "ss-topic-done" : "ss-topic-pending"
          }`}
        >
          {isCompleted ? (
            <CheckCircle2 size={16} />
          ) : (
            <Circle size={16} />
          )}
        </span>
        <div className="ss-topic-content">
          <span className="ss-topic-name">{topic.name}</span>
          {linkedMaterials.length > 0 && (
            <div className="ss-topic-materials">
              {linkedMaterials.map((mat) => (
                <button
                  key={mat._id}
                  className="ss-material-chip"
                  onClick={() => handleDownload(mat)}
                  disabled={downloading === mat._id}
                  title={`Download ${mat.title}`}
                >
                  <FileText size={11} />
                  <span>{mat.title}</span>
                  {mat.fileType && <span className="ss-material-type">{mat.fileType}</span>}
                  <Download size={10} />
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Right: recording link */}
      <div className="ss-topic-right">
        {hasRecording && (
          <a
            href={topic.recordingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="ss-recording-link"
          >
            <Video size={13} />
            Recording
          </a>
        )}
      </div>
    </div>
  );
};

export default StudentTopicRow;
